import React, { lazy } from 'react';
import PrivateRoute from 'PrivateRoutes';
const InboundBlock = lazy(()=> import(/* webpackChunkName: "InboundBlock" */'./components'));

const routes = () => (
    <PrivateRoute exact path="/settings/inbound-block" component={InboundBlock} />
);

export default routes;



// WEBPACK FOOTER //
// src/modules/screens/settings/InboundBlock/routes.js